module.exports = __webpack_public_path__ + "img/ddos-c.7eebc2f.svg";